import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  TextField,
  Popover,
  Paper,
  InputAdornment,
  Checkbox,
  Chip,
  Grid,
  Autocomplete,
  CircularProgress,
  Menu,
  MenuItem,
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Collapse, Divider } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Search, Print, Download, Edit, Delete } from "@mui/icons-material";
import {
  fetchpos,
  deletepos,
  ApprovePO,
  fetchSuppliers,
} from "../../../Services/Services";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { handlePrint } from "./PurchaseOrderPrint";
import InfiniteScroll from "react-infinite-scroll-component";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

pdfMake.vfs = pdfFonts.vfs;
const calculateValue = (item) => {
  let val = item.qty * item.price - item.discount;
  return (val + (val * item.tax) / 100).toFixed(2);
};

const ProjectList = () => {
  const [po, setpos] = useState([]);
  const [projects, setProjects] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [poToDelete, setPoToDelete] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [poToApprove, setPoToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [showRemarkForPoId, setShowRemarkForPoId] = useState(null);
  const [filters, setFilters] = useState({
    po_number: "",
    supplier: "",
    date_range: "today", // ✅ Add this
  });
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPO, setExpandedPO] = useState(null);

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleReset = () => {
    setFilters({
      po_number: "", // ✅ Fix field names
      supplier: "", // ✅ Fix field names
      date_range: "today",
    });
    setCustomDateRange({ from: "", to: "" });
    setTempCustomDateRange({ from: "", to: "" }); // ✅ Add
    setShowCustomDateInputs(false); // ✅ Add
  };

  // ✅ Handle Custom Date Range Apply
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Handle Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     setPage(1);
  //     loadPo(1, true, filters);
  //   }, 1000);
  //   return () => {
  //     clearTimeout(handler);
  //   };
  // }, [filters]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      const updatedFilters = {
        ...filters,
        from_date: customDateRange.from || "", // ✅ Add
        to_date: customDateRange.to || "", // ✅ Add
      };
      loadPo(1, true, updatedFilters);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [filters, customDateRange]); // ✅ Add customDateRange dependency
  useEffect(() => {
    const loadSuppliers = async () => {
      try {
        const data = await fetchSuppliers();

        setSuppliers(Array.isArray(data) ? data : data.results || []);
      } catch (error) {
        console.error("Failed to load suppliers", error);
      }
    };

    loadSuppliers();
  }, []);
  const loadPo = async (pageNum = 1, reset = false, filterValues = filters) => {
    try {
      const data = await fetchpos(filterValues, pageNum);
      if (reset || pageNum === 1) {
        setProjects(Array.isArray(data) ? data.results : data.results || []);
      } else {
        setProjects((prev) => [
          ...prev,
          ...(Array.isArray(data) ? data.results : data.results || []),
        ]);
      }
      setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
      setPage(pageNum);
    } catch (error) {
      console.error("Failed to load po", error);
      toast.error("Failed to load po");
    }
  };
  // const fetchMoreData = () => {
  //   const nextPage = page + 1;
  //   setPage(nextPage);
  //   loadPo(nextPage);
  // };

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    const updatedFilters = {
      ...filters,
      from_date: customDateRange.from || "", // ✅ Add
      to_date: customDateRange.to || "", // ✅ Add
    };
    loadPo(nextPage, false, updatedFilters); // ✅ Pass filters
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

const handleApprove = async (po) => {
  const approvedById = Number(localStorage.getItem("user_id"));
  if (!approvedById) {
    toast.error("Approver ID not found.");
    return;
  }

  const isApproval = po.approval_status === "Approved";

  try {
    const updated = await ApprovePO(
      po.po_id,
      approvedById,
      po.approval_status,
      remarkInput
    );

    setpos((prev) =>
      prev.map((item) => (item.po_id === po.po_id ? updated : item))
    );

    const UpdtedList = await fetchpos(filters);
    setProjects(UpdtedList.results);

    // Show appropriate toast based on status
    if (isApproval) {
      toast.success("PO approved successfully!");
    } else {
      toast.warning("PO rejected!");
    }

  } catch (error) {
    console.error("Error:", error);
    toast.error(
      isApproval
        ? "Failed to approve PO."
        : "Failed to reject PO."
    );
  }
};

  // Decide which form to open based on your API shape
  const isPoWithoutIndent = (po) => {
    // Prefer explicit flags if available:
    if (typeof po.is_without_indent !== "undefined")
      return !!po.is_without_indent;
    if (typeof po.po_type !== "undefined")
      return String(po.po_type).toLowerCase().includes("without");

    // Fallback: if there's no indent, treat it as "without indent"
    return !po.indent && !po.indent_id;
  };

  const handleEdit = (po) => {
    const path = isPoWithoutIndent(po)
      ? "/dashboard/powithoutindent"
      : "/dashboard/po-form";

    navigate(path, { state: { poData: po, isEdit: true } });
  };

  const handleDeleteClick = (po) => {
    setPoToDelete(po);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await deletepos(poToDelete.po_id);
      setProjects((prev) => prev.filter((p) => p.po_id !== poToDelete.po_id));
      setPoToDelete(null);
      toast.success("Purchase order deleted successfully");
    } catch (error) {
      console.error("Delete failed", error);
      toast.error("Failed to delete purchase order");
    }
  };

  const handleClick = () => {
    // navigate("/dashboard/po-form");
      navigate("/dashboard/powithoutindent");
  };
  const handlePOwithoutIndent = () => {
    navigate("/dashboard/powithoutindent");
  };
  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const userRole = localStorage.getItem("role");

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0]; // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);
  return (
    // <Box sx={{ backgroundColor: "#fff", p: 2 }}>
    <Box sx={{ px: 0, pt: 0, mt: -3, maxWidth: 1200, mx: "auto" }}>
      <Box
        sx={{
          mt: -3,
          pt: 0,
          mb: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Grid container spacing={1} alignItems="center">
          {/* Date Range Dropdown */}
          <Grid item xs={12} sm={2.5}>
            <TextField
              fullWidth
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                  padding: "4px 8px",
                },
                "& .MuiInputBase-root": {
                  height: 32,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Search PO Number */}
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              label="Search PO Number"
              size="small"
              name="po_number"
              value={filters.po_number}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Search Supplier */}
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              label="Search Supplier"
              size="small"
              name="supplier"
              value={filters.supplier}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 32,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Reset Button */}
          <Grid item xs={4} sm={1.2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: 32,
                fontSize: { xs: "0.6rem", sm: "0.7rem" },
                borderRadius: 0,
                padding: "0 8px",
                minWidth: 0,
              }}
            >
              Reset
            </Button>
          </Grid>

          {/* Purchase Order Button */}
          {/* <Grid item xs={4} sm={2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleClick}
              sx={{
                height: 32,
                fontSize: { xs: "0.55rem", sm: "0.65rem" },
                borderRadius: 0,
                padding: "0 4px",
                minWidth: 0,
                "& .MuiButton-startIcon": {
                  margin: "0 2px 0 0",
                  "& > *:nth-of-type(1)": {
                    fontSize: { xs: "14px", sm: "16px" },
                  },
                },
              }}
              startIcon={<AddIcon />}
            >
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                Purchase Order
              </Box>
              <Box
                component="span"
                sx={{ display: { xs: "inline", sm: "none" } }}
              >
                PO
              </Box>
            </Button>
          </Grid> */}

          {/* PO without Indent Button */}
          <Grid item xs={4} sm={2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleClick}
              sx={{
                height: 32,
                fontSize: { xs: "0.55rem", sm: "0.65rem" },
                borderRadius: 0,
                padding: "0 4px",
                minWidth: 0,
                "& .MuiButton-startIcon": {
                  margin: "0 2px 0 0",
                  "& > *:nth-of-type(1)": {
                    fontSize: { xs: "14px", sm: "16px" },
                  },
                },
              }}
              startIcon={<AddIcon />}
            >
              <Box
                component="span"
                sx={{ display: { xs: "none", sm: "inline" } }}
              >
                Purchase Order
              </Box>
              <Box
                component="span"
                sx={{ display: { xs: "inline", sm: "none" } }}
              >
                Purchase Order
              </Box>
            </Button>
          </Grid>
        </Grid>

        {/* Date Range Menu - UPDATED */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: {
              width: 350,
              maxHeight: 500,
              "& .MuiTypography-root": {
                fontSize: "0.7rem",
              },
            },
          }}
        >
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
            { key: "current_year", label: "Current Year" },
            { key: "financial_year", label: "Financial Year" },
          ].map((range) => (
            <MenuItem
              key={range.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: range.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{range.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.65rem" }}
                >
                  {getDateRangeDisplay(range.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          {/* ✅ Both Date Pickers Together */}
          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempCustomDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <InfiniteScroll
        dataLength={projects.length}
        next={fetchMoreData}
        hasMore={hasMore}
        height={"85vh"}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more pos!</p>}
      >
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper" }}>
            {projects.map((po, index) => (
              <Box key={po.id}>
                <Box
                  onClick={() =>
                    setExpandedPO(expandedPO === po.id ? null : po.id)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${
                      po.approval_status === "Approved"
                        ? "#4caf50"
                        : po.approval_status === "Reject"
                          ? "#f44336"
                          : "#ff9800"
                    }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {po.po_number}
                      </Typography>
                      {/* <Chip
                        label={
                          po.approval_status === "Approved"
                            ? "✓"
                            : po.approval_status === "Reject"
                            ? "✗"
                            : "⏱"
                        }
                        color={
                          po.approval_status === "Approved"
                            ? "success"
                            : po.approval_status === "Reject"
                            ? "error"
                            : "warning"
                        }
                        size="small"
                        sx={{
                          height: 20,
                          minWidth: 30,
                          fontSize: "0.7rem",
                          "& .MuiChip-label": { px: 0.5 },
                        }}
                      /> */}
                    </Box>

                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {suppliers
                          .find((s) => s.id === po.supplier)
                          ?.name?.substring(0, 20) || `Supplier ${po.supplier}`}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatOnlyDate(po.created_at)}
                      </span>
                    </Typography>
                  </Box>

                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedPO === po.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedPO === po.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${
                        po.approval_status === "Approved"
                          ? "#4caf50"
                          : po.approval_status === "Reject"
                            ? "#f44336"
                            : "#ff9800"
                      }`,
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          SUPPLIER
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {suppliers.find((s) => s.id === po.supplier)?.name ||
                            `Supplier ${po.supplier}`}
                        </Typography>
                      </Box>

                      {po.created_by_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {po.created_by_name}
                          </Typography>
                        </Box>
                      )}

                      {po.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {po.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        BILLING ADDRESS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                        }}
                      >
                        {po.billing_address}
                      </Typography>
                    </Box>

                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        SHIPPING ADDRESS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                        }}
                      >
                        {po.shipping_address}
                      </Typography>
                    </Box>

                    {po.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {po.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              po.approval_status === "Approved"
                                ? "#e8f5e9"
                                : po.approval_status === "Reject"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${
                              po.approval_status === "Approved"
                                ? "#4caf50"
                                : po.approval_status === "Reject"
                                  ? "#f44336"
                                  : "#ff9800"
                            }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              po.approval_status === "Approved" ||
                              po.approval_status === "Reject"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPoToApprove(po);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                po.approval_status === "Approved"
                                  ? "#4caf50"
                                  : po.approval_status === "Reject"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  po.approval_status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                po.approval_status === "Approved"
                                  ? "#2e7d32"
                                  : po.approval_status === "Reject"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {po.approval_status === "Approved"
                              ? "Approved"
                              : po.approval_status === "Reject"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(po);
                          }}
                          disabled={po.approval_status === "Approved"}
                          sx={{
                            bgcolor: "#e3f2fd",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#bbdefb",
                              transform: "scale(1.05)",
                            },
                            "&:disabled": {
                              bgcolor: "#f5f5f5",
                              opacity: 0.5,
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Edit sx={{ fontSize: "1rem", color: "#1976d2" }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setAnchorEl(e.currentTarget);
                            setPoToDelete(po);
                          }}
                          disabled={po.approval_status === "Approved"}
                          sx={{
                            bgcolor: "#ffebee",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffcdd2",
                              transform: "scale(1.05)",
                            },
                            "&:disabled": {
                              bgcolor: "#f5f5f5",
                              opacity: 0.5,
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Delete sx={{ fontSize: "1rem", color: "#d32f2f" }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePrint(po);
                          }}
                          sx={{
                            bgcolor: "#f3e5f5",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#e1bee7",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#7b1fa2" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                <Divider />
              </Box>
            ))}
          </Box>
        ) : (
          /* 💻 DESKTOP TABLE VIEW */
          <TableContainer component={Paper} sx={{ overflow: "unset" }}>
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.8rem !important",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                        minWidth: 80,
                      }}
                      align="center"
                    >
                      Approve
                    </TableCell>
                  )}

                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 80,
                    }}
                    align="center"
                  >
                    S.No.
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 160 : 80,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 120,
                    }}
                    align="center"
                  >
                    PO Number
                  </TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Supplier</TableCell>
                  <TableCell align="center">Billing Address</TableCell>
                  <TableCell align="center">Shipping Address</TableCell>
                  <TableCell align="center">Created At</TableCell>
                  <TableCell align="center">Created By</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">Remarks</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 4,
                    }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {projects.map((po, index) => (
                  <React.Fragment key={po.id}>
                    <TableRow
                      hover
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:hover": {
                          backgroundColor: "#e3f2fd",
                          "& td": {
                            backgroundColor: "#e3f2fd !important",
                          },
                        },
                        "& td": {
                          paddingRight: "13px !important",
                          paddingLeft: "13px !important",
                          padding: "0px",
                          fontSize: { xs: "0.8rem !important", sm: "0.75rem" },
                          whiteSpace: "nowrap",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#fafafa",
                            zIndex: 2,
                            minWidth: 80,
                          }}
                          align="center"
                        >
                          <Checkbox
                            checked={
                              po.approval_status === "Approved" ||
                              po.approval_status === "Rejected"
                            }
                            onChange={(e) => {
                              setApproveAnchorEl(e.currentTarget);
                              setPoToApprove(po);
                            }}
                            sx={{
                              padding: 0,
                              paddingLeft: 1,
                              paddingRight: 1,
                              transform: "scale(0.6)",
                              color:
                                po.approval_status === "Approved"
                                  ? "green"
                                  : po.approval_status === "Rejected"
                                    ? "red"
                                    : "grey",
                              "&.Mui-checked": {
                                color:
                                  po.approval_status === "Approved"
                                    ? "green"
                                    : "red",
                              },
                            }}
                          />
                        </TableCell>
                      )}

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 80 : 0,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                          minWidth: 80,
                        }}
                        align="center"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 160 : 80,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                          minWidth: 120,
                        }}
                        align="center"
                      >
                        {po.po_number}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            po.approval_status === "Approved"
                              ? "Approved"
                              : po.approval_status === "Rejected"
                                ? "Reject"
                                : "Pending"
                          }
                          color={
                            po.approval_status === "Approved"
                              ? "success"
                              : po.approval_status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">{po.supplier_name}</TableCell>
                      <TableCell align="center">
                        <Tooltip title={po.billing_address} arrow>
                          <span>{truncateText(po.billing_address, 20)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        {po.shipping_address}
                      </TableCell>
                      <TableCell>{formatOnlyDate(po.created_at)}</TableCell>
                      <TableCell align="center">
                        {po.created_by_name ? po.created_by_name : "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {po.approved_name ? po.approved_name : ""}
                      </TableCell>
                      <TableCell align="center">{po.remarks || ""}</TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          zIndex: 3,
                        }}
                        align="center"
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="primary"
                          onClick={() => handleEdit(po)}
                          disabled={po.approval_status === "Approved"}
                        >
                          <Edit transform="scale(0.6)" />
                        </IconButton>
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            setPoToDelete(po);
                          }}
                          disabled={po.approval_status === "Approved"}
                          color="error"
                          size="small"
                        >
                          <Delete transform="scale(0.6)" />
                        </IconButton>
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="primary"
                          onClick={() => handlePrint(po)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      <ToastContainer position="top-right" autoClose={3000} />

      <Popover
        open={Boolean(approveAnchorEl)}
        onClose={() => {
          setApproveAnchorEl(null);
          setPoToApprove(null);
          setRemarkInput("");
        }}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            width: 750,
            height: 600,
            borderRadius: 2,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {poToApprove && (
          <>
            {/* ================= HEADER (FIXED) ================= */}
            <Box
              sx={{
                py: 1,
                px: 2,
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f4f6f8",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                Purchase Order Preview
              </Typography>
              <Typography variant="body2" color="text.secondary">
                PO Number: {poToApprove?.po_number || "-"}
              </Typography>
            </Box>

            {/* ================= BODY - SCROLLABLE ================= */}
            <Box
              sx={{
                p: 2,
                overflowY: "auto",
                flex: 1,
                backgroundColor: "#fff",
              }}
            >
              {/* Top Details Grid */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  border: "1px solid #000",
                  mb: 2,
                }}
              >
                {/* Recipient (Billed To) */}
                <Box sx={{ p: 2, borderRight: "1px solid #000" }}>
                  <Typography fontWeight={600}>
                    Details of Recipient (Billed to)
                  </Typography>
                  <Typography variant="body2">
                    Name: {poToApprove?.billed_to_name || "-"}
                  </Typography>
                  <Typography variant="body2">
                    Address: {poToApprove?.billed_to_address || "-"}
                  </Typography>
                  <Typography variant="body2">
                    GSTIN: {poToApprove?.billed_to_gst_no || "-"}
                  </Typography>
                  <Typography variant="body2">
                    Contact: {poToApprove?.billed_to_contact || "-"}
                  </Typography>
                </Box>

                {/* PO Info */}
                <Box sx={{ p: 2 }}>
                  <Typography variant="body2">
                    <strong>PO Number:</strong> {poToApprove?.po_number || "-"}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Date:</strong>{" "}
                    {poToApprove?.created_at
                      ? new Date(poToApprove.created_at).toLocaleDateString(
                          "en-IN",
                        )
                      : "-"}
                  </Typography>
                 
                </Box>
              </Box>

              {/* Supplier Section (Billed From) */}
              <Box
                sx={{
                  border: "1px solid #000",
                  p: 2,
                  mb: 2,
                }}
              >
                <Typography fontWeight={600}>
                  Details of Supplier (Billed from)
                </Typography>
                <Typography variant="body2">
                  Name: {poToApprove?.billing_name || "-"}
                </Typography>
                <Typography variant="body2">
                  Address: {poToApprove?.billing_address || "-"}
                </Typography>
                <Typography variant="body2">
                  GSTIN: {poToApprove?.billing_gst || "-"}
                </Typography>
              </Box>

              {/* Items Table */}
              <Table size="small" sx={{ border: "1px solid #000" }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: 700 }}>S No.</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Item</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Product Type</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Unit</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Quantity</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Rate</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Amount</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {poToApprove?.items?.length > 0 ? (
                    <>
                      {poToApprove.items.map((item, index) => (
                        <TableRow key={item.id || index} sx={{
                          "& td": {
                            borderBottom: "1px solid #ccc", 
                          },
                        }}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.item_name || "-"}</TableCell>
                          <TableCell>{item.size_name || "-"}</TableCell>
                          <TableCell>{item.unit_name || "-"}</TableCell>
                          <TableCell>{item.main_quantity || 0}</TableCell>
                          <TableCell>{item.rate || 0}</TableCell>
                          <TableCell>{item.amount || 0}</TableCell>
                        </TableRow>
                      ))}
                      {/* Total Row */}
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          align="left"
                          sx={{
                            fontWeight: 700,
                            borderTop: "2px solid #000",
                            // backgroundColor: "#f5f5f5",
                          }}
                        >
                          Total:
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            borderTop: "2px solid #000",
                            // backgroundColor: "#f5f5f5",
                          }}
                        >
                          ₹{" "}
                          {poToApprove?.items
                            ?.reduce((sum, item) => sum + (item.amount || 0), 0)
                            ?.toLocaleString("en-IN") || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No Items Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>

            {/* ================= FOOTER (FIXED) ================= */}
            <Box
              sx={{
                p: 2,
                borderTop: "1px solid #e0e0e0",
                backgroundColor: "#fafafa",
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
              }}
            >
              <TextField
                size="small"
                label="Remark"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark..."
                sx={{ flexGrow: 1 }}
              />

              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  if (!remarkInput.trim()) {
                    toast.error("Remark is required!");
                    return;
                  }
                  handleApprove({
                    ...poToApprove,
                    approval_status: "Approved",
                    remarks: remarkInput,
                  });
                  setApproveAnchorEl(null);
                  setPoToApprove(null);
                  setRemarkInput("");
                }}
              >
                Approve
              </Button>

              <Button
                variant="contained"
                color="error"
                disabled={poToApprove?.approval_status === "Approved"}
                onClick={() => {
                  if (!remarkInput.trim()) {
                    toast.error("Remark is required!");
                    return;
                  }
                  handleApprove({
                    ...poToApprove,
                    approval_status: "Rejected",
                    remarks: remarkInput,
                  });
                  setApproveAnchorEl(null);
                  setPoToApprove(null);
                  setRemarkInput("");
                }}
              >
                Reject
              </Button>

              <Button
                variant="outlined"
                color="primary"
                onClick={() => handleEdit(poToApprove)}
                disabled={poToApprove?.approval_status === "Approved"}
              >
                Edit
              </Button>

              <Button
                variant="outlined"
                onClick={() => {
                  setApproveAnchorEl(null);
                  setPoToApprove(null);
                  setRemarkInput("");
                }}
              >
                Close
              </Button>
            </Box>
          </>
        )}
      </Popover>

      {/* Delete popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setPoToDelete(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 200 }}>
          <Typography variant="body2" gutterBottom>
            Are you sure you want to delete <strong>{poToDelete?.name}</strong>?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setPoToDelete(null);
              }}
            >
              Close
            </Button>
            <Button
              size="small"
              color="error"
              onClick={async () => {
                await confirmDelete(poToDelete);
                setAnchorEl(null);
                setPoToDelete(null);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default ProjectList;
